import { createFileRoute } from '@tanstack/react-router'
import LoginForm from '@/components/login-route/login-form'
import RenderBackgroundIcon from '@/components/custom/backgroundIcon'

export const Route = createFileRoute('/_public/login')({
  component: Login,
})

function Login() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#f8fafc]">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -right-1/4 top-0 h-1/2 w-1/2 rounded-full bg-blue-600 opacity-10 blur-3xl" />
        <div className="absolute -left-1/4 bottom-0 h-1/2 w-1/2 rounded-full bg-blue-400 opacity-10 blur-3xl" />
        <RenderBackgroundIcon animate />
      </div>

      <div className="container relative mx-auto flex min-h-screen items-center justify-center px-4">
        <div className="mx-auto w-full max-w-md space-y-8">
          <div className="rounded-2xl border border-blue-100 bg-white/70 p-8 shadow-xl backdrop-blur-lg">
            <div className="mb-8 space-y-2">
              <h1 className="text-center text-2xl font-bold tracking-tight text-primary">
                Zenify
              </h1>
              <p className="text-center text-foreground">
                Tổng đài đa kênh hợp nhất cho doanh nghiệp
              </p>
            </div>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  )
}
